import React, { FC } from 'react';
import { css } from 'linaria';
import cn from 'clsx';

import LazyImage from '../LazyImage';

import AppLink from '../AppLink';

const InternalBackgroundStyles = css`
  overflow: auto;

  & > div {
    position: relative;
  }
`;

const CategoryTile: FC<Tile> = ({ aspectRatio, href, image, name, tracking }) => (
  <AppLink className="block relative overflow-hidden rounded-lg" href={href} tracking={tracking}>
    <span className="absolute left-3 top-3 heading-xxsmall text-lapel w-24 z-10">{name}</span>
    <LazyImage aspectRatio={aspectRatio} className={InternalBackgroundStyles} image={image} />
  </AppLink>
);

interface Tile {
  href: string;
  image: string;
  aspectRatio: string;
  name: string;
  tracking: any;
}

interface Props {
  className?: string;
  tiles: Tile[];
}

const FlyerCategoryTiles: FC<Props> = ({ className, tiles }) => {
  return (
    <div className="mx-4 mb-4">
      <h3 className="tracked-medium m-4 text-center">Popular Categories</h3>
      <div className={cn(className, 'grid grid-cols-2 gap-4')}>
        {tiles && tiles.map((tile: Tile, index: number) => <CategoryTile key={index} {...tile} />)}
      </div>
    </div>
  );
};

export default FlyerCategoryTiles;
